import axios from 'axios'
import { useInfiniteScroll } from './useInfiniteScroll'

export interface RecipesResponse<T> {
  recipes: T[]
  page: number
  has_more_records_in_scope: boolean
}

interface ActiveRecipesParams {
  query?: string
  type?: string
}

export function useActiveRecipes<T>({ query, type }: ActiveRecipesParams) {
  const fetchPage = (page: number, signal: AbortSignal) =>
    axios
      .get<RecipesResponse<T>>('/recipes/active.json', { params: { query, type, page }, signal })
      .then(({ data }) => ({ items: data.recipes, hasMoreRecordsInScope: data.has_more_records_in_scope }))

  const { items, ...rest } = useInfiniteScroll<T>(fetchPage, [query, type])
  return { recipes: items, ...rest }
}
